import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "@/core/utils/date";
import { IPayout } from "@/payouts/payouts";

export const DatePaidCol = (): ColumnDef<IPayout> => ({
  header: "Date paid",
  accessorFn: (row) => row.created_at,
  cell: ({ row }) => formatDate(row.original.created_at),
});
